module.exports = {"id":"176211","name":"Marcin Robak","rating":"72","photo":"./data/images/photos/3/176211.png","club":{"name":"Śląsk Wrocław","logo":"./data/images/clubs/SlaskWrocław.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcinRobak0.json
// module id = 2727
// module chunks = 0